import { render, staticRenderFns } from "./allCreated.vue?vue&type=template&id=666f511c"
import script from "./allCreated.vue?vue&type=script&lang=ts"
export * from "./allCreated.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports